/* eslint-disable react/no-array-index-key */
import { fetchCategories } from "@/apis/queryFunctions/categoryFunctions";
import { fetchEcompage, useFetchEcompage } from "@/apis/queryFunctions/ecompagesFunctions";
import { categoryKeys, ecompagesKeys, } from "@/apis/queryKeys";
import DefaultSEO from "@/common/components/DefaultSEO";
import HomeNews from "@/common/components/HomeNews";
import PageContainer from "@/common/components/PageContainer";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import { Box, Skeleton } from "@mantine/core";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import Image from "next/image";
import { useRouter } from "next/router";
import topPage from "public/HeadOfPage.png";
import React from "react";
import Info from "./components/Info";

export default function NoiDia({ dataSEO }) {
  const { locale } = useRouter();
  const { data: detail } = useFetchEcompage("trang-noi-dia-viet-thien", locale);

  return (
    <>
      <DefaultSEO seo={dataSEO} />
      <div>
        <Skeleton visible={!detail}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              aspectRatio: "2.55",
            }}
          >
            {Boolean(detail) && detail?.picture && (
              <Image
                src={appendImageUrlFromAPI({
                  src: detail?.picture,
                  size: "xl",
                })}
                alt={detail?.title}
                layout="fill"
                priority
                quality={100}
              />
            )}
          </Box>
          <Box sx={{ objectPosition: "bottom", marginTop: "-5%" }}>
            <Image
              src={topPage}
              alt="paint"
              objectFit="cover"
            />
          </Box>
        </Skeleton>

        <Box pos="relative"
          sx={{
            paddingBottom: "100px"
          }}
        >
          <Box sx={{ zIndex: 2 }}>


            <PageContainer>
              <Info />
            </PageContainer>

            <Box size="xl"
              sx={{
                background: "#F8F8F8",
                padding: "1px 0 70px 0"
              }}>

              <HomeNews />
            </Box>
          </Box>
        </Box>
      </div>
    </>
  );
}

export async function getStaticProps({ locale }) {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery(ecompagesKeys.detail("trang-noi-dia-viet-thien"), () =>
    fetchEcompage("trang-noi-dia-viet-thien", locale)
  );
  await queryClient.prefetchQuery(categoryKeys.all, () => fetchCategories({ condition: { highlight: true } }))

  const seoData = await fetchEcompage("trang-noi-dia-viet-thien", locale);

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      dataSEO: {
        title: seoData?.meta_title || "Nông sản Việt Thiên - Nông sản Việt vươn xa",
        description: seoData?.meta_description || seoData?.add_on_data?.[4]?.content,
        keywords: seoData?.meta_keywords || null,
        picture1: seoData?.meta_picture_1 || null,
        picture2: seoData?.meta_picture_2 || null,
      },
    },
    revalidate: 60,
  };
}

